import { createContext } from 'react';

import type { IOrderWizardContext } from './types';

export default createContext<IOrderWizardContext>({
  updateLastDeliveryDetails: () => {},
  resetDeliveryDetails: () => {},
});
